// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background-color: var(--color-blue-cream) !important;
  font-family: "Lexend", sans-serif;
  border-top: 4px solid var(--color-white-main) !important;
}

footer .footer-container {
  width: 70%;
  height: auto;
  margin: auto;
  padding: 50px 0px;
  display: flex;
  column-gap: 30px;
  justify-content: center;
}

footer .footer-container .footer-left {
  width: 25% !important;
}

footer .footer-container .footer-left img {
  width: 275px;
  height: auto;
}

footer .footer-container .footer-left p {
  font-size: 14px;
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
}

footer .footer-container .footer-left ul {
  display: flex;
  margin-top: 15px;
}

footer .footer-container .footer-left ul li {
  list-style: none;
  margin: 0px 24px 0px 0px;
}

footer .footer-container .footer-left ul li a {
  display: block;
  width: 42px;
  height: 42px;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  border-radius: 8px;
  color: var(--color-blue-dark);
  background-color: var(--color-white-main);
  border: 1px solid var(--color-border-gray);
}

footer .footer-container .footer-left ul li a:hover {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
}

footer .footer-container .footer-center {
  width: 50% !important;
}

footer .footer-container .footer-center h5 {
  font-family: "Lexend Deca", sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  color: var(--color-text-dark);
}

footer .footer-container .footer-center p {
  margin-top: 10px;
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
}

footer .footer-container .footer-right {
  width: 25% !important;
}

footer .footer-container .footer-right h5 {
  font-family: "Lexend Deca", sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  color: var(--color-text-dark);
}

footer .footer-container .footer-right a {
  display: block;
  margin: 10px 0px 0px 0px;
  color: var(--color-text-gray);
  text-decoration: none;
  font-family: "Lexend Deca", sans-serif;
}

footer .footer-container .footer-right .logo-href {
  margin: 0;
}

footer .footer-container .footer-right a:hover {
  text-decoration: underline;
}

footer .footer-container .footer-right img {
  width: 160px;
  height: auto;
  display: block;
}

footer .footerButtom {
  width: 100%;
  padding: 25px 0px;
  text-align: center;
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
  font-size: 16px;
  font-family: "Lexend Deca", sans-serif;
}

footer .footerButtom a {
  color: var(--color-white-main);
  text-decoration: none;
}

footer .footerButtom a:hover {
  text-decoration: underline;
}

footer .whatsaap-flotante {
  display: block !important;
  position: fixed;
  right: 35px;
  bottom: 35px;
  z-index: 30;
}

@media only screen and (max-width: 600px) {
  footer .footer-container {
    width: 90% !important;
    height: auto;
    margin: auto;
    padding: 14px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    column-gap: 0px !important;
  }

  footer .footer-container .footer-left,
  footer .footer-container .footer-center,
  footer .footer-container .footer-right {
    width: 100% !important;
  }

  footer .footer-container .footer-left p {
    font-size: 15px;
    margin: 5px 0px;
  }

  footer .footer-container .footer-center {
    margin: 25px 0px;
    padding-left: 0px !important;
  }

  footer .footerButtom {
    width: 100%;
    padding: 25px 5%;
    font-size: 10px;
  }

  footer .whatsaap-flotante {
    display: block !important;
    position: fixed;
    right: 25px;
    z-index: 30;
  }

  footer .footer-container .footer-left img {
    width: 201px;
  }

  footer .footer-container .footer-center h5, footer .footer-container .footer-right h5  {
    font-size: 17px;
  }

  footer .footer-container .footer-center p, footer .footer-container .footer-right a {
    font-size: 15px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  footer .footer-container {
    width: 90% !important;
    height: auto;
    margin: auto;
    padding: 50px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    column-gap: 0px !important;
  }

  footer .footer-container .footer-left {
    width: 100% !important;
  }

  footer .footer-container .footer-left p {
    font-size: 19px;
    margin: 5px 0px;
  }

  footer .footer-container .footer-center {
    width: 50% !important;
    padding: 0px !important;
    margin: 25px 0px;
  }

  footer .footer-container .footer-right {
    width: 50% !important;
    padding: 0 !important;
    margin: 25px 0px;
  }

  footer .footer-container .footer-right img {
    display: inline !important;
    margin: 0px 15px 0px 0px;
    width: 165px;
  }

  footer .footer-container .footer-right img:nth-last-child(2) {
    margin-bottom: -5px;
  }

  footer .footerButtom {
    width: 100%;
    padding: 25px 5%;
    font-size: 13px;
  }

  footer .footer-container .footer-left ul li a {
    display: block;
    width: 46px;
    height: 46px;
    font-size: 23px;
    line-height: 46px;
  }

  footer .whatsaap-flotante {
    display: block !important;
    position: fixed;
    right: 25px;
    bottom: 35px;
    z-index: 30;
  }
}

@media only screen and (min-width: 1025px) {
  footer .footer-container {
    width: 75%;
    height: auto;
    margin: auto;
    padding: 50px 0px;
    display: flex;
    justify-content: center;
    column-gap: 20px !important;
  }

  footer .footer-container .footer-left {
    width: 30% !important;
  }

  footer .footer-container .footer-center {
    width: 70% !important;
    padding-left: 70px !important;
  }

  footer .footer-container .footer-right {
    width: 40% !important;
  }
}

@media only screen and (min-width: 1600px) {
  footer .footer-container .footer-center {
    padding-left: 200px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/footer/Footer.css"],"names":[],"mappings":"AAEA;EACE,oDAAoD;EACpD,iCAAiC;EACjC,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["@import url(../../../App.css);\n\nfooter {\n  background-color: var(--color-blue-cream) !important;\n  font-family: \"Lexend\", sans-serif;\n  border-top: 4px solid var(--color-white-main) !important;\n}\n\nfooter .footer-container {\n  width: 70%;\n  height: auto;\n  margin: auto;\n  padding: 50px 0px;\n  display: flex;\n  column-gap: 30px;\n  justify-content: center;\n}\n\nfooter .footer-container .footer-left {\n  width: 25% !important;\n}\n\nfooter .footer-container .footer-left img {\n  width: 275px;\n  height: auto;\n}\n\nfooter .footer-container .footer-left p {\n  font-size: 14px;\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\nfooter .footer-container .footer-left ul {\n  display: flex;\n  margin-top: 15px;\n}\n\nfooter .footer-container .footer-left ul li {\n  list-style: none;\n  margin: 0px 24px 0px 0px;\n}\n\nfooter .footer-container .footer-left ul li a {\n  display: block;\n  width: 42px;\n  height: 42px;\n  text-align: center;\n  line-height: 40px;\n  font-size: 18px;\n  border-radius: 8px;\n  color: var(--color-blue-dark);\n  background-color: var(--color-white-main);\n  border: 1px solid var(--color-border-gray);\n}\n\nfooter .footer-container .footer-left ul li a:hover {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n}\n\nfooter .footer-container .footer-center {\n  width: 50% !important;\n}\n\nfooter .footer-container .footer-center h5 {\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: var(--color-text-dark);\n}\n\nfooter .footer-container .footer-center p {\n  margin-top: 10px;\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\nfooter .footer-container .footer-right {\n  width: 25% !important;\n}\n\nfooter .footer-container .footer-right h5 {\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: var(--color-text-dark);\n}\n\nfooter .footer-container .footer-right a {\n  display: block;\n  margin: 10px 0px 0px 0px;\n  color: var(--color-text-gray);\n  text-decoration: none;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\nfooter .footer-container .footer-right .logo-href {\n  margin: 0;\n}\n\nfooter .footer-container .footer-right a:hover {\n  text-decoration: underline;\n}\n\nfooter .footer-container .footer-right img {\n  width: 160px;\n  height: auto;\n  display: block;\n}\n\nfooter .footerButtom {\n  width: 100%;\n  padding: 25px 0px;\n  text-align: center;\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n  font-size: 16px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\nfooter .footerButtom a {\n  color: var(--color-white-main);\n  text-decoration: none;\n}\n\nfooter .footerButtom a:hover {\n  text-decoration: underline;\n}\n\nfooter .whatsaap-flotante {\n  display: block !important;\n  position: fixed;\n  right: 35px;\n  bottom: 35px;\n  z-index: 30;\n}\n\n@media only screen and (max-width: 600px) {\n  footer .footer-container {\n    width: 90% !important;\n    height: auto;\n    margin: auto;\n    padding: 14px 0px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    column-gap: 0px !important;\n  }\n\n  footer .footer-container .footer-left,\n  footer .footer-container .footer-center,\n  footer .footer-container .footer-right {\n    width: 100% !important;\n  }\n\n  footer .footer-container .footer-left p {\n    font-size: 15px;\n    margin: 5px 0px;\n  }\n\n  footer .footer-container .footer-center {\n    margin: 25px 0px;\n    padding-left: 0px !important;\n  }\n\n  footer .footerButtom {\n    width: 100%;\n    padding: 25px 5%;\n    font-size: 10px;\n  }\n\n  footer .whatsaap-flotante {\n    display: block !important;\n    position: fixed;\n    right: 25px;\n    z-index: 30;\n  }\n\n  footer .footer-container .footer-left img {\n    width: 201px;\n  }\n\n  footer .footer-container .footer-center h5, footer .footer-container .footer-right h5  {\n    font-size: 17px;\n  }\n\n  footer .footer-container .footer-center p, footer .footer-container .footer-right a {\n    font-size: 15px;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  footer .footer-container {\n    width: 90% !important;\n    height: auto;\n    margin: auto;\n    padding: 50px 0px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    column-gap: 0px !important;\n  }\n\n  footer .footer-container .footer-left {\n    width: 100% !important;\n  }\n\n  footer .footer-container .footer-left p {\n    font-size: 19px;\n    margin: 5px 0px;\n  }\n\n  footer .footer-container .footer-center {\n    width: 50% !important;\n    padding: 0px !important;\n    margin: 25px 0px;\n  }\n\n  footer .footer-container .footer-right {\n    width: 50% !important;\n    padding: 0 !important;\n    margin: 25px 0px;\n  }\n\n  footer .footer-container .footer-right img {\n    display: inline !important;\n    margin: 0px 15px 0px 0px;\n    width: 165px;\n  }\n\n  footer .footer-container .footer-right img:nth-last-child(2) {\n    margin-bottom: -5px;\n  }\n\n  footer .footerButtom {\n    width: 100%;\n    padding: 25px 5%;\n    font-size: 13px;\n  }\n\n  footer .footer-container .footer-left ul li a {\n    display: block;\n    width: 46px;\n    height: 46px;\n    font-size: 23px;\n    line-height: 46px;\n  }\n\n  footer .whatsaap-flotante {\n    display: block !important;\n    position: fixed;\n    right: 25px;\n    bottom: 35px;\n    z-index: 30;\n  }\n}\n\n@media only screen and (min-width: 1025px) {\n  footer .footer-container {\n    width: 75%;\n    height: auto;\n    margin: auto;\n    padding: 50px 0px;\n    display: flex;\n    justify-content: center;\n    column-gap: 20px !important;\n  }\n\n  footer .footer-container .footer-left {\n    width: 30% !important;\n  }\n\n  footer .footer-container .footer-center {\n    width: 70% !important;\n    padding-left: 70px !important;\n  }\n\n  footer .footer-container .footer-right {\n    width: 40% !important;\n  }\n}\n\n@media only screen and (min-width: 1600px) {\n  footer .footer-container .footer-center {\n    padding-left: 200px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
